//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface Address {
    line1: string;
    line2: string | null;
    line3: string | null;
    line4: string | null;
    locality: string | null;
    region: string | null;
    postcode: string;
    country: string | null;
    latitude: string | null;
    longitude: string | null;
    source: string | null;
}

export interface Client {
    dateCreated: string;
    id: string;
    recordVersion: string;
    name: string;
    businessPhoneNumber: string;
    physicalAddress: Address;
    shippingNotes: string | null;
    shipToPhysicalAddress: boolean;
    billingAddress: Address | null;
    externalProvidedDataId: string | null;
    clientOwnerId: string;
    state: ClientState;
}

export interface ClientPrimaryContact {
    dateCreated: string;
    id: string;
    recordVersion: string;
    clientId: string;
    contactId: string | null;
}

export enum ClientState {
    Active = 0,
    Archived = 1,
}

export interface Contact {
    dateCreated: string;
    id: string;
    recordVersion: string;
    name: string;
    title: string | null;
    email: string;
    mobile: string | null;
    clientId: string;
}

export interface InputCreateClient {
    client: Client;
}

export interface InputCreateContact {
    contact: Contact;
    isPrimary: boolean;
}

export interface InputUpdateClient {
    client: Client;
}

export interface InputUpdateContact {
    contact: Contact;
    isPrimary: boolean;
}

export interface RequestBrowseClientSummary {
    clientOwnerId: string | null;
    filterActive: boolean | null;
    filter: string | null;
    pageSize: number;
    pageIndex: number;
    sortField: string | null;
    sortAsc: boolean;
}

export interface RequestBrowseContactSummary {
    clientOwnerId: string | null;
    clientId: string | null;
    filter: string | null;
    pageSize: number;
    pageIndex: number;
    sortField: string | null;
    sortAsc: boolean;
}

export interface RequestGetClient {
    clientId: string;
}

export interface RequestGetClientListByIds {
    clientIds: string[];
}

export interface RequestGetClientPrimaryContactByIds {
    clientIds: string[];
}

export interface RequestGetClientSummary {
    clientId: string;
}

export interface RequestGetContact {
    contactId: string;
}

export interface RequestGetContactListByIds {
    contactIds: string[];
}

export interface ResultBrowseClientSummary {
    clientSummary: ViewClientSummaryResultPaginated;
}

export interface ResultBrowseClientSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultBrowseClientSummary | null;
}

export interface ResultBrowseContactSummary {
    contactSummary: ViewContactSummaryResultPaginated;
}

export interface ResultBrowseContactSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultBrowseContactSummary | null;
}

export interface ResultCreateClient {
    client: Client;
}

export interface ResultCreateClientServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateClient | null;
}

export interface ResultCreateContact {
    contact: Contact;
}

export interface ResultCreateContactServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateContact | null;
}

export interface ResultGetClient {
    client: Client;
}

export interface ResultGetClientListByIds {
    clients: Client[];
}

export interface ResultGetClientListByIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClientListByIds | null;
}

export interface ResultGetClientPrimaryContactByIds {
    clientPrimaryContacts: ClientPrimaryContact[];
}

export interface ResultGetClientPrimaryContactByIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClientPrimaryContactByIds | null;
}

export interface ResultGetClientServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClient | null;
}

export interface ResultGetClientSummary {
    clientSummary: ViewClientSummary;
}

export interface ResultGetClientSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClientSummary | null;
}

export interface ResultGetContact {
    contact: Contact;
}

export interface ResultGetContactListByIds {
    contacts: Contact[];
}

export interface ResultGetContactListByIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetContactListByIds | null;
}

export interface ResultGetContactServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetContact | null;
}

export interface ResultUpdateClient {
    client: Client;
}

export interface ResultUpdateClientServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateClient | null;
}

export interface ResultUpdateContact {
    contact: Contact;
}

export interface ResultUpdateContactServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateContact | null;
}

export interface ServiceResponseError {
    message: string;
    stackTrace: string | null;
}

export enum ServiceResponseType {
    None = 0,
    Ok = 1,
    NotFound = 2,
    UnAuthenticated = 4,
    UnAuthorized = 8,
    Error = 16,
    TransientDbError = 32,
    ValidationFailure = 64,
    ModifyNotFound = 128,
}

export interface ViewClientSummary {
    id: string;
    clientOwnerId: string;
    name: string;
    primaryContactId: string | null;
    primaryContactName: string | null;
    primaryContactEmail: string | null;
    physicalAddress: Address | null;
}

export interface ViewClientSummaryResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: ViewClientSummary[];
}

export interface ViewContactSummary {
    id: string;
    name: string;
    isPrimary: boolean;
    title: string;
    email: string;
    mobile: string | null;
    clientId: string;
    clientName: string;
}

export interface ViewContactSummaryResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: ViewContactSummary[];
}